import React from "react";
import PropTypes from "prop-types";
import CardBadge from "../CardBadge/CardBadge";
import CardPublishDate from "./CardPublishDate";

const CardPublishContent = ({ children = null, className = "" }) => {
  return <div className={`card__meta--content ${className}`}>{children}</div>;
};

CardPublishContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default Object.assign(CardPublishContent, {
  Badge: CardBadge,
  PublishDate: CardPublishDate
});
